class DiscountCode extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			discountCode: '.discount-code__copy',
			tooltip: 'custom-tooltip',
			discountCodeContainer: '.discount-code__cupon',
		};

		this.elements = {
			discountCode: document.querySelector(this.selectors.discountCode),
			tooltip: document.querySelector(this.selectors.tooltip),
			discountCodeContainer: document.querySelector(this.selectors.discountCodeContainer),
		};

		this.expirationDate = this.dataset.expirationDate;
	}

	connectedCallback() {
		this.init();
	}

	init() {
		if (!this.isExpired()) {
			this.addListeners();
		}
	}

	isExpired() {
		if (this.expirationDate && this.isValidDateTimeFormat(this.expirationDate)) {
			const expirationDate = new Date(this.expirationDate);
			const today = new Date();

			if (today > expirationDate) {
				this.style.display = 'none';
				return true;
			}
		}
		this.style.display = 'flex';
		return false;
	}

	isValidDateTimeFormat(str) {
		var regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;

		if (!regex.test(str)) {
			return false;
		}

		var dateTime = new Date(str);
		return !isNaN(dateTime.getTime());
	}

	addListeners() {
		this.elements.discountCodeContainer.addEventListener('click', () => {
			this.copyToClipboard();
		});
	}

	copyToClipboard() {
		navigator.clipboard.writeText(this.elements.discountCode.innerHTML.trim());
		this.elements.tooltip.innerHTML = this.elements.tooltip.dataset.confirmation;
	}
}

customElements.define('discount-code', DiscountCode);
